// Pages that paint their own layout (chat, search, knowledge base, ...) run
// edge-to-edge in .app-content--chat. The tabs below only set text and need a
// plainly scrolling themed page instead (.app-content--surface, index.css).
export const SURFACE_TABS = new Set(["agents", "collections", "connectors", "audit"]);

const FILES_TAB = "files";

export function appContentClass(activeTab) {
  if (activeTab === FILES_TAB) return "app-content";
  return SURFACE_TABS.has(activeTab)
    ? "app-content app-content--chat app-content--surface"
    : "app-content app-content--chat";
}
